import React from 'react';
import { TabItem } from './components/topbar/tab-item';
import { Tab, useTabParams, useTabManager } from './tab-manager';
import { NotFound } from '../app/components';

export const NotFoundTab: React.FC<{
  title?: string;
  resource?: string;
}> = ({ title, resource }) => {
  const { tabId, ...rest } = useTabParams<{ tabId: string }>();
  const { close } = useTabManager();

  return (
    <>
      <Tab tabId={tabId} params={rest}>
        <TabItem
          tab={{
            id: tabId,
            title: title ?? 'Not Found',
            showClose: true,
          }}
        />
      </Tab>
      <NotFound resource={resource} onClose={() => close(tabId)} />
    </>
  );
};
